export default function ForgotPasswordForm({
    email,
    onEmailChange,
    onSubmit,
    error,
    success,
    onBack
}) {
    return (
        <>
            <h1>Forgot password</h1>
            <p className="auth-subtitle">Enter your email and we&apos;ll send a link to reset your password.</p>

            <form onSubmit={onSubmit} className="auth-form">
                <input type="email" className="input-field" placeholder="you@company.com" value={email} onChange={e => onEmailChange(e.target.value)} autoFocus required />

                {error && <div className="auth-error"><i className="fa-solid fa-triangle-exclamation"></i>{error}</div>}
                {success && <div className="auth-success">{success}</div>}

                <button type="submit" className="btn-primary auth-submit">Continue</button>
            </form>

            <p className="auth-switch">
                <button type="button" className="auth-link muted" onClick={onBack}>Back to sign in</button>
            </p>
        </>
    );
}
